module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"inn_any_country":"Налоговый номер в стране регистрации","register_button":"Зарегистрироваться"},"en":{"inn_any_country":"Tax number","register_button":"Register"}}')
  delete Component.options._Ctor
}
